import { useEffect, useState } from "react"
import { getAppIds } from "../../services/api"

const AppMonitoring = () => {

    const [appIds, setAppIds] = useState()

    useEffect(() => {
        const fetchAppIds = async () => {
            let resp = await getAppIds()
            setAppIds(resp?.data?.appIds)
        }
        fetchAppIds()
    }, [])
    return (
        <div>
            { appIds?.length === 0 ? <p>You dont have access to any app</p> :

            <div>
                {
                    appIds?.map(elm => (
                        <p>{elm}</p>
                    ))
                }
            </div>
            
            }
        </div>
    )
}

export default AppMonitoring